import { useEffect } from 'react';

export const isValidChiliPiperSubmission = values => {
  const isValidChiliPiperSubmission =
    values?.industry === 'HVAC' ||
    values?.industry === 'Plumbing' ||
    values?.industry === 'Garage Door' ||
    values?.industry === 'Electrical';
  const hasValidChiliPiperNumbers =
    parseInt(values?.techniciansNumber) >= 2 && parseInt(values?.officeStaffNumber) >= 1;
  if (
    isValidChiliPiperSubmission &&
    hasValidChiliPiperNumbers &&
    typeof window !== 'undefined' &&
    window.location.pathname === '/go/brand-ce'
  ) {
    return true;
  } else return false;
};

export const useChiliPiperLoad = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.pathname === '/go/brand-ce') {
      var forms2Script = document.createElement('script');
      forms2Script.type = 'text/javascript';
      forms2Script.id = 'mktoForm_2175';
      forms2Script.src = '//app-ab07.marketo.com/js/forms2/js/forms2.min.js';
      document.body.appendChild(forms2Script);

      var chiliPiperScript = document.createElement('script');
      chiliPiperScript.type = 'text/javascript';
      chiliPiperScript.id = 'cp-form';
      chiliPiperScript.src = 'https://js.chilipiper.com/marketing.js';
      document.body.appendChild(chiliPiperScript);
    }
  }, []);
  return true;
};
